import {
  EMAIL_PATTERN,
  PASSWORD_LETTER_PATTERN,
  PASSWORD_NUMBER_PATTERN,
  PASSWORD_SPECIAL_CHARS_PATTERN
} from 'helpers/Constants';
import { postData } from 'helpers/RequestHelper';
import { required } from 'helpers/CommonValidations';
import { trackFieldUpdate } from 'helpers/DarkMagicianRequest';

const validateIncludesUsername = (value, email) => {
  if (email) {
    const username = email.split('@')[0].toLowerCase();
    if (value.toLowerCase().includes(username)) {
      return { password: 'Cannot contain your OppLoans username' };
    }
  }
  return { password: '' };
};

const validations = {
  email: (state) => {
    const value = state.email;
    if (!value) {
      return required('email', value);
    }
    if (!value.match(EMAIL_PATTERN)) {
      return { email: 'Invalid Email' };
    }
    return { email: '' };
  },
  emailBriteVerify: async (state) => {
    const value = state.email;
    const errorMessage = await new window.HeadlessCaptcha()
      .whenValidate()
      .then((data) => {
        return postData({
          url: '/register/validate_email_authenticity',
          body: {
            google_recaptcha_token: data?.token,
            user: { email: value }
          }
        })
          .then((response) => {
            if (response.data.is_authentic) {
              trackFieldUpdate('email', value, 'String');
            }
            return response.data.is_authentic
              ? ''
              : `Sorry, we can't verify that email address. Please enter a valid email address.`;
          })
          .catch((err) => {
            const response = err.response;
            window.Raven.captureException(response.data.error, {
              extra: {
                heapEvent: '[validate][email][failed]',
                source: 'validate.emailBriteVerify'
              }
            });
            window.postHeapAnalytic('track', '[validate][email][failed]', {
              statusText: response.statusText,
              error: response.data.error
            });

            // Let customer continue if server error occurs
            return '';
          });
      })
      .catch((err) => {
        window.Raven.captureException('Error when generating captcha token', {
          extra: {
            heapEvent: '[captcha][token][failed]',
            source: 'validate.emailBriteVerify',
            error: err
          }
        });
        window.postHeapAnalytic('track', '[captcha][token][failed]');

        return '';
      });
    return { email: errorMessage };
  },
  password: (state) => {
    const value = state.password;
    if (!value) {
      return required('password', value);
    }
    if (value.length < 12) {
      return { password: 'Must be 12 or more characters long' };
    }
    if (!value.match(PASSWORD_LETTER_PATTERN)) {
      return { password: 'Must include upper and lowercase letters' };
    }
    if (!value.match(PASSWORD_NUMBER_PATTERN)) {
      return { password: 'Must include at least 1 number' };
    }
    if (!value.match(PASSWORD_SPECIAL_CHARS_PATTERN)) {
      return {
        password: 'Must include at least 1 special character (@$!%*#?& )'
      };
    }
    if (
      state.passwordConfirmation &&
      state.password !== state.passwordConfirmation
    ) {
      return {
        password: 'Passwords do not match'
      };
    }
    return validateIncludesUsername(value, state.email);
  }
};

export default validations;
export const emailBriteVerifyValidation = validations.emailBriteVerify;
